import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CardsState } from '../../types';

import { getActiveCards } from '../operations/getActiveCards';

import { STATUS_LOADING } from 'common/constants';

export const setActiveCards = (builder: ActionReducerMapBuilder<CardsState>) => builder
  .addCase(getActiveCards.pending, (state) => {
    state.activeCards.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getActiveCards.fulfilled, (state, { payload }) => {
    state.activeCards.loadingStatus = STATUS_LOADING.done;
    state.activeCards.data = payload;
  })
  .addCase(getActiveCards.rejected, (state) => {
    state.activeCards.loadingStatus = STATUS_LOADING.error;
  });